<template>
  <div>
    <Table border :columns="columns"
           :data="tableData"
           :loading="tableLoading"
           @on-selection-change="tableSelectionChange"
           @on-sort-change="projectListTableSortChange"
           style="margin-top: 10px;">
      <template slot-scope="{ row }" slot="title">
        <a href="javascript:void(0)" v-html="row.title" @click="jumpProjectDetail(row)"></a>
      </template>
    </Table>

    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pageSize"
      :pager-count="5"
      layout="total, sizes, prev, pager, next, jumper"
      :total="tableTotal"
      style="margin-top: 10px">
    </el-pagination>
  </div>
</template>

<script>
import { contentType, exportFile } from "../apis/common";

export default {
  name: 'AnalysisProject', // 分析页面项目列表
  props: ['condition'],
  data () {
    return {
      tableLoading: false,
      columns: [
        {
          title: this.$t('table.project.main.title'),
          slot: 'title',
          minWidth:300,
          className:'table-head-style',
        },
        {
          title: this.$t('table.project.main.amount'),
          key: 'amount',
          width: 170,
          align: 'right',
          // sortable: true
          className:'table-head-style',
          sortable: 'custom'
        },
        {
          title: this.$t('table.project.main.industry'),
          key: 'industry',
          width: 140,
          // sortable: true
          className:'table-head-style',
          sortable: 'custom'
        },
        {
          title: this.$t('table.project.main.state'),
          key: 'status',
          width: 120,
          // sortable: true
          className:'table-head-style',
          sortable: 'custom'
        },
        {
          title: this.$t('table.project.main.country'),
          key: 'country',
          width: 120,
          className:'table-head-style',
          // sortable: true
          sortable: 'custom'
        },
        {
          title: this.$t('table.project.main.date'),
          key: 'signDate',
          width: 130,
          align: 'center',
          sortable: 'custom'
          // render: (h, params) => {
          //   debugger
          //   return h('span', self.$moment(params.row.pubDate).format('yyyy-MM-DD'))
          // }
        }
      ],
      selections:[],
      tableData: [],
      tableSelection: [],
      currentPage: 1,
      pageSize: 10,
      tableTotal: 0,
      queryParams: {},
      locale: localStorage.getItem('locale'),
    }
  },
  methods: {
    jumpProjectDetail (row) {
      this.$router.push({
        name: 'pbrProjectDetail',
        params: {row},
        query: {key: row.id}
      })
    },

      projectListTableSortChange (options) {
          let {column, key, order} = options
          // 综合：zh 金额：je  行业：hy  状态：zt   国家：gj   日期：rq   默认是综合
          let orderkeyEnum = {
              'amount': 'je',
              'industry': 'hy',
              'pubDate': 'rq',
              'status': 'zt',
              'country': 'gj'
          }
          this.queryParams.orderby = order
          this.queryParams.orderkey = orderkeyEnum[key]
          this.getProjectData()
      },

    tableSelectionChange (selection) {
      this.tableSelection = selection
    },

    handleSizeChange (val) {
      this.pageSize = val
      if (this.queryParams.id) {
        this.getHistoryTableData(this.queryParams.id)
      } else {
        this.getProjectData()
      }
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.queryParams.id) {
        this.getHistoryTableData(this.queryParams.id)
      } else {
        this.getProjectData()
      }
    },
    getProjectData (num) {
      let param = {
        from: this.locale,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
       if(num){
        param.pageSize=num
      }
      console.log('search')
      param = Object.assign(param, this.queryParams)
      console.log(param)
      this.tableLoading = true
      this.$pbrAxios.post('/front/project/search', param).then((data) => {
        if (data.success) {
          this.tableTotal = data.result.rows
          if(num){
 this.tableData = data.result.models.slice(0,10)
 this.selections=data.result.models.map(item=>item.id)
          }else{
             this.tableData = data.result.models
          }
        } else {
          this.tableTotal = 0
          this.tableData = []
          //this.$iMessage.error({content: data.message})
        }
        this.tableLoading = false
      })
    },
 downFile(){
 exportFile(
          this.$pbrApis.exportProjectListExcelUrl,
          {
            selections: this.selections.join(','),
            from: this.locale
          },
          this.$t("label.export.projectList"),
          contentType.excel,
          ".xlsx"
        );
    },
    getHistoryTableData (id) {
      let param = {
        from: this.locale,
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        id: id
      }
      this.tableLoading = true
      this.$pbrAxios.post('/front/project/hsearch', param).then((data) => {
        console.log(data)
        this.tableLoading = false
        this.tableTotal = data.result.rows
        this.tableData = data.result.models
      })
    }
  },
  watch: {
    condition: function (newval) {
      this.queryParams = newval
      this.currentPage = 1
      this.pageSize = 10
      if (this.queryParams.id) {
        this.getHistoryTableData(this.queryParams.id)
      } else {
        this.getProjectData(50)
      }
    }
  }
}
</script>

<style scoped>

</style>
